var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTrainerQaAPI } from '../selectors';
import { CalculatorForm } from './calculatorForm';
import { INTERACTION_INPUT, QA_ROLE } from './constants';
import { useCalculatorRoleSync } from './useCalculatorRoleSync';
var calculateInteractionQARatio = function (formData) {
  var percentInteraction = formData.percentInteraction || 0;
  var numberMonitorReq = formData.numberInteraction * percentInteraction * 0.01;
  var evalCompletionTime = formData.evalCompletionTime || 0;
  var totalEvalTime = formData.baseInteractionAHT + evalCompletionTime;
  var productionHour = numberMonitorReq * totalEvalTime / 3600;
  var shrinkage = formData.shrinkage || 0;
  var staffEstimate = Math.ceil(productionHour / 150 / (1 - shrinkage * 0.01));
  var qaRatio = staffEstimate ? Math.ceil(formData.numberReqAgent / staffEstimate) : null;
  return __assign(__assign({}, formData), {
    percentInteraction: percentInteraction,
    evalCompletionTime: evalCompletionTime,
    shrinkage: shrinkage,
    numberMonitorReq: Math.ceil(numberMonitorReq),
    totalEvalTime: Math.round(totalEvalTime),
    productionHour: Math.round(productionHour),
    staffEstimate: staffEstimate,
    qaRatio: qaRatio
  });
};
export var InteractionForm = function (_a) {
  var setValue = _a.setValue,
    watch = _a.watch;
  var qaData = useTrainerQaAPI()[0];
  var _b = useForm(),
    control = _b.control,
    reset = _b.reset,
    handleSubmit = _b.handleSubmit;
  var _c = useCalculatorRoleSync(QA_ROLE, watch, setValue),
    isFTEBased = _c.isFTEBased,
    selectedLocationId = _c.selectedLocationId,
    setSelectedLocationId = _c.setSelectedLocationId,
    applyRatioToRoles = _c.applyRatioToRoles;
  useEffect(function () {
    if (qaData.data) {
      reset({
        baseInteractionAHT: qaData.data.interactionAht,
        numberInteraction: Math.round(qaData.data.interaction),
        interactionAHT: Math.round(qaData.data.interactionAht),
        numberReqAgent: isFTEBased ? qaData.data.agentsFte : qaData.data.headcountFte
      });
    }
  }, [isFTEBased, reset, qaData.data]);
  var handleFormSubmit = handleSubmit(function (values) {
    var newValues = calculateInteractionQARatio(values);
    reset(newValues);
    if (newValues.qaRatio) {
      applyRatioToRoles(newValues.qaRatio);
    }
  });
  return _jsx(CalculatorForm, {
    data: INTERACTION_INPUT,
    control: control,
    onSubmit: handleFormSubmit,
    selectedLocationId: selectedLocationId,
    onLocationChange: setSelectedLocationId
  });
};